import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { RegistrosService } from '../registros.service';
import { ApiService } from 'app/core/services/api.service';

@Component({
    selector: 'cargar-plantilla',
    templateUrl: 'cargar-plantilla.component.html',
    standalone: true,
    imports:[
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,

    ]
})

export class CargarPlantillaComponent implements OnInit {
    @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
    isDraggingOver = false;
    documentos: File[] = [];
    subiendoPlantilla = false;

    constructor(
        public dialogRef: MatDialogRef<CargarPlantillaComponent>,
        private _registrosService: RegistrosService,
        private _apiService: ApiService
    ) {

    }

    ngOnInit() {

    }

    cerrar(): void {
        if (this.subiendoPlantilla) {
            return;
        }
        this.dialogRef.close(false);
    }


    uploadImage() {
        this.fileInput.nativeElement.click();
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        if (this.subiendoPlantilla) {
            return;
        }
        this.isDraggingOver = true;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        if (this.subiendoPlantilla) {
            return;
        }
        this.isDraggingOver = false;
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        if (this.subiendoPlantilla) {
            return;
        }
        this.isDraggingOver = false;
        if (event.dataTransfer?.files.length > 0) {
        this.handleFiles(event.dataTransfer.files);
        }
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (this.subiendoPlantilla) {
            return;
        }
        if (input.files?.length) {
        this.handleFiles(input.files);
        }
    }

    handleFiles(files: FileList): void {
        const file = files[0];

        const isValidType =
            file.type === 'application/pdf' ||
            file.name.toLowerCase().endsWith('.pdf');

        if (!isValidType) {
            this._apiService.showErrorMessage('Solo se permiten archivos PDF');
            return;
        }

        this.documentos = [file];
    }

    borrar(index: number) {
        this.documentos.splice(index, 1);
    }

    guardarPlantilla(): void {
        const file = this.documentos[0];
        if (!file) {
            return;
        }

        this.subiendoPlantilla = true;
        this._registrosService.subirPlantilla(file)
            .then((response: any) => {
                if (response?.isSuccess) {
                    this._apiService.showSuccessMessage(response?.message ?? 'Se ha guardado la plantilla correctamente');
                    this.dialogRef.close(true);
                } else {
                    const detalle = response?.message || response?.exceptionMessage || 'No se pudo guardar la plantilla';
                    this._apiService.showErrorMessage(detalle);
                }
            })
            .catch(() => {
                this._apiService.showErrorMessage('No se pudo guardar la plantilla');
            })
            .finally(() => {
                this.subiendoPlantilla = false;
            });
    }
}
